
<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Add training</strong>
          </div>
          <b-form>
            <b-form-group
              label="Team"
              label-for="localTeamSelect"
              :label-cols="3"
              :horizontal="true">
              <b-form-select id="localTeamSelect"
                :plain="true"
                :options="teamsNamesArray"
                value="Select team..."
                v-model="currentTeam"
                v-on:change="setTeam">
              </b-form-select>
            </b-form-group>
            <b-form-group>
              <b-form-input id="trainingTitle" 
                        type="text" 
                        autocomplete="name" 
                        v-model="trainingData.title" 
                        size="lg" 
                        placeholder="Enter training title...">
              </b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-textarea id="trainingDescription"
                        v-model="trainingData.description"
                        placeholder="Enter training description..."
                        :rows="3"
                        :max-rows="6"
                        size="sm">
              </b-form-textarea>
            </b-form-group>
            <b-form-group validated
              label="Date" label-for="date"
              :label-cols="3"
              :horizontal="true">
              <b-form-input type="date" required id="date" 
              v-model="trainingData.date"></b-form-input>
            </b-form-group>
            <b-form-group validated
              label="Hour" label-for="hour"
              :label-cols="3"
              :horizontal="true">
              <b-form-input type="time" required id="hour" 
              v-model="trainingData.hour"></b-form-input>
            </b-form-group>
            <b-form-group validated
              label="Duration (minutes)" label-for="duration"
              :label-cols="3"
              :horizontal="true">
              <b-form-input type="number" required id="duration" 
              v-model="trainingData.duration"></b-form-input>
            </b-form-group>
            <b-form-group validated
              label="Location" label-for="location"
              :label-cols="3"
              :horizontal="true">
              <gmap-autocomplete
                style="width:100%; height:100%"
                placeholder="Training location..."
                @place_changed="setPlaceLocation">
              </gmap-autocomplete>
            </b-form-group>
            <b-form-group v-if="marker != null"
              label="Extra information" label-for="extraInformation"
              :label-cols="3"
              :horizontal="true">
              <b-form-input type="text" required id="extraInformation" 
              v-model="trainingData.location.information"></b-form-input>
            </b-form-group>
            <b-form-group  v-if="marker != null">
              <gmap-map
                :center="center"
                :zoom="15"
                style="width:100%;  height: 400px;">
                <gmap-marker
                  v-model="marker"
                  :position="marker"
                ></gmap-marker>
              </gmap-map>
            </b-form-group>
          <div slot="footer">
            <b-row class="align-items-center">
              <b-col xl= "2" class="mb-3 mb-xl-0" >
                <b-button v-on:click="goBack" block variant="secondary">Back</b-button>
              </b-col>
              <b-col xl= "6" class="mb-3 mb-xl-0" >
                <b-button type="submit" v-if="!isEdit" v-on:click="confirmTrainingButton" block variant="primary"><i class="fa fa-dot-circle-o"></i> Confirm Training</b-button>
                <b-button type="submit" v-if="isEdit" v-on:click="updateTraining" block variant="primary"><i class="fa fa-dot-circle-o"></i> Save Changes</b-button>
              </b-col>
              <b-col xl= "4" class="mb-3 mb-xl-0" >
                <!-- <b-button v-if="isEdit" v-on:click="removeTraining" block variant="danger"><i class="fa fa-ban"></i> Remove Training</b-button> -->
              </b-col>
            </b-row>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <!-- ******************* -->
    <!--     Attachments      -->
    <!-- ******************* -->

    <b-row>
      <b-col xs="12" md="4"  xl="4" v-if="isEdit">
        <image-attachment :type="type" :typeId="trainingData.key" :teamId="trainingData.teamKey"> </image-attachment>
      </b-col>
          <b-col xs="12" md="4"  xl="4" v-if="isEdit">
        <video-attachment :type="type" :typeId="trainingData.key" :teamId="trainingData.teamKey"> </video-attachment>
      </b-col>
          <b-col  xs="12" md="4"  xl="4" v-if="isEdit">
        <file-attachment :type="type" :typeId="trainingData.key" :teamId="trainingData.teamKey"> </file-attachment>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { storage } from '@/config/devowqlo';
import { auth } from '@/config/devowqlo';
import { functions } from '@/config/devowqlo';
import  imageAttachment   from '@/views/attachments/ImageAttachment';
import  videoAttachment   from '@/views/attachments/VideoAttachment';
import  fileAttachment   from '@/views/attachments/FileAttachment';
export default {
  components: {
    imageAttachment: imageAttachment,
    videoAttachment: videoAttachment,
    fileAttachment: fileAttachment,
  }, 
  name: 'forms',
  firebase: {
    teams: db.ref('teams'),
    trainings: db.ref('teamTrainings'),
    categories: db.ref('categories'),
    counts: db.ref('counts')
  },
  props: {
    caption: {
      type: String,
      default: 'Team id'
    },
    captionImages: {
      type: String,
      default: 'Images'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      type: "training",
      isEdit: false,
      currentTeam: null,
      trainingData: {
        key: null,
        title: null,
        description: null,
        date: null,
        hour: null,
        duration: null,
        teamKey: null,
        team: {
          name: null,
          logoUrl: null,
          thumbLogoUrl: null,
          category: null
        },
        location: {
          name: null,
          information: null,
          latitude: null,
          longitude: null
        }
      },
      center: null,
      marker: null,
      teamsArray: [],
      teamsNamesArray: [],
      imagesSelected: [],
      previewImage: null,
      previewImageUrl: null,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
    }
  },
  created() {

    if(this.$route.params.info){
      const infoString = String(this.$route.params.info)
      const infoSplit = infoString.split('&&')
      this.trainingData.key = infoSplit[0]
      this.trainingData.teamKey = infoSplit[1]
      this.setTraining()
    }

    db.ref('teams').once('value', (snapshot) =>{
          this.teamsNamesArray = []
          this.teamsArray = []
          snapshot.forEach(categorySnapshot => {
            categorySnapshot.forEach(teamSnapshot => {
              console.log(teamSnapshot)
              this.teamsNamesArray.push(teamSnapshot.val().name + ' · ' + this.getCategoryName(teamSnapshot.val().category))
              this.teamsArray.push(teamSnapshot)

              if(teamSnapshot.key == this.trainingData.teamKey){
                this.currentTeam = teamSnapshot.val().name + ' · ' + this.getCategoryName(teamSnapshot.val().category)
              }
            })
          })
        })

  },
  methods: {
    getThumbImage(thumbUrl){
      console.log(thumbUrl)

      // var realThumbUrl = null
      // storage.ref().child("TrainingAttachments").child('Images').child(thumbUrl).getDownloadURL().then((url) => {
      //   realThumbUrl = url
        
      // }).catch(function(error) {
      //   // Handle any errors
      // });



    },

    setPlaceLocation(place){
      console.log(place)
      //Set training info
      this.trainingData.location = {
        name: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      }

      //Add marker to map
      this.marker = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      this.center = this.marker


    },
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    setTraining(){
      this.isEdit = true
      this.$firebaseRefs.trainings.child(this.trainingData.teamKey).child(this.trainingData.key).
          once('value', (snap) => {
            console.log(snap)
      
            this.trainingData.team.name = Object.values(snap.val().team)[0].name
            this.trainingData.team.category = Object.values(snap.val().team)[0].category
            this.trainingData.team.logoUrl = Object.values(snap.val().team)[0].logoUrl
            this.trainingData.team.thumbLogoUrl = Object.values(snap.val().team)[0].thumbLogoUrl

            this.trainingData.title = snap.val().title
            this.trainingData.description = snap.val().description
            this.trainingData.date = snap.val().date
            this.trainingData.hour = snap.val().hour
            this.trainingData.duration = snap.val().duration
            this.trainingData.location = snap.val().location



            this.marker = {
              lat: snap.val().location.latitude,
              lng: snap.val().location.longitude
            };
            this.center = this.marker

          });
    },
    removeTraining(){

      // this.$firebaseRefs.events.child(this.eventData.key).remove()

      // var countRef = this.$firebaseRefs.counts.child('eventsCount').child('count')

      // countRef.transaction(function(count) {
      //   if (count) {
      //     if(count > 0){
      //       count = count - 1;
      //     }
      //   }else{
      //     count = 0
      //   }
      //   return count;
      // })

      // this.$router.go(-1)
      
    },
    updateTraining(){
      const dateNow = Date.now()
      var trainingModel = { 
        timeStamp: new Date( this.trainingData.date + " " + this.trainingData.hour).getTime(),
        title: this.trainingData.title,
        description: this.trainingData.description,
        date: this.trainingData.date,
        hour: this.trainingData.hour,
        duration: this.trainingData.duration,
        location: this.trainingData.location,
        modified: dateNow
      }

      this.$firebaseRefs.trainings.child(this.trainingData.teamKey).child(this.trainingData.key).update(trainingModel)
      this.$firebaseRefs.trainings.child(this.trainingData.teamKey).child(this.trainingData.key).child('team').child(this.trainingData.teamKey).set(this.trainingData.team)
      
      var notificationModel = {
        type: 'training',
        typeId: this.trainingData.key,
        typeName: this.trainingData.team.name,
        action: 'modified',
        timestamp: dateNow,
         viewed: false 
      }

      // NEW!!
      db.ref('trainingControl').child('viewControl').child(this.trainingData.teamKey).child(this.trainingData.key).child('pending').set(null)
      db.ref('trainingControl').child('viewControl').child(this.trainingData.teamKey).child(this.trainingData.key).child('seen').set(null)
      db.ref('trainingControl').child('availabilityControl').child(this.trainingData.teamKey).child(this.trainingData.key).child('noAvailbale').set(null)

      // Members
      db.ref('teamMembers').child(this.trainingData.teamKey).child('members').once('value', (snapshot) =>{
        snapshot.forEach(childSnapshot => {
          var notificationKey = db.ref('userNotifications').child(childSnapshot.key).child('notifications').push(notificationModel).key
          db.ref('userNotifications').child(childSnapshot.key).child('notifications').child(notificationKey).child('team').child(this.trainingData.teamKey).set(this.trainingData.team)
          db.ref('userPending').child(childSnapshot.key).child('pendingTrainings').child(this.trainingData.key).set(true)

          // NEW!!
          var userSimpleModel = {
            name: childSnapshot.val().name,
            lastName: childSnapshot.val().lastName
          }

          if( childSnapshot.child('role').val() == "player" ){
            db.ref('trainingControl').child('viewControl').child(this.trainingData.teamKey).child(this.trainingData.key).child('pending').child(childSnapshot.key).set(userSimpleModel)
            db.ref('trainingControl').child('availabilityControl').child(this.trainingData.teamKey).child(this.trainingData.key).child('available').child(childSnapshot.key).set(userSimpleModel)
          }
        })
      })
      this.$router.go(-1)
    },
    getCategoryName(categoryId){
      var foundCategory = this.categories.find(category => category['.key'] === categoryId)
      if(foundCategory){
        return foundCategory.name
      }else{
        return ""
      }
      
    },
    getTeams(teams){
      
    },
    setTeam(value){
      console.log(value)
      var teamName = value.split(' · ')[0]
      this.teamsArray.forEach(snap => {
      console.log("local team", snap)
      var element = snap.val()
       if(element.name == teamName){
         console.log("setting team")
         this.trainingData.teamKey = snap.key
         this.trainingData.team.name = element.name
         this.trainingData.team.logoUrl = element.logoUrl
         this.trainingData.team.thumbLogoUrl = element.thumbLogoUrl
         this.trainingData.team.category = element.category
       }
      });
    },
    confirmTrainingButton () {
      this.addTraining()
    },
    addTraining(){

      this.createTrainingDb();
    },
    createTrainingDb(){
      
      console.log("1. Creating training on DB...")
       
      const dateNow = Date.now()

      var trainingModel = { 
        timeStamp: new Date( this.trainingData.date + " " + this.trainingData.hour).getTime(),
        title: this.trainingData.title,
        description: this.trainingData.description,
        date: this.trainingData.date,
        hour: this.trainingData.hour,
        duration: this.trainingData.duration,
        location: this.trainingData.location,
        created: dateNow,
        modified: dateNow
      }
      console.log("2. trainingData.teamKey..." + this.trainingData.teamKey)
      var trainingKey = this.$firebaseRefs.trainings.child(this.trainingData.teamKey).push(trainingModel).key
      this.$firebaseRefs.trainings.child(this.trainingData.teamKey).child(trainingKey).child('team').child(this.trainingData.teamKey).set(this.trainingData.team)

      console.log(trainingKey)
      var notificationModel = {
        type: 'training',
        typeId: trainingKey,
        typeName: this.trainingData.title,
        action: 'created',
        timestamp: dateNow,
         viewed: false 
      }

      db.ref('teamMembers').child(this.trainingData.teamKey).child('members').once('value', (snapshot) =>{
        snapshot.forEach(childSnapshot => {
          // console.log(childSnapshot.val())
          var notificationKey = db.ref('userNotifications').child(childSnapshot.key).child('notifications').push(notificationModel).key
          db.ref('userNotifications').child(childSnapshot.key).child('notifications').child(notificationKey).child('team').child(this.trainingData.teamKey).set(this.trainingData.team)
          db.ref('userPending').child(childSnapshot.key).child('pendingTrainings').child(trainingKey).set(true)

          // NEW!!
          var userSimpleModel = {
            name: childSnapshot.val().name,
            lastName: childSnapshot.val().lastName,
            thumbPictureUrl: childSnapshot.val().thumbPictureUrl
          }

          if( childSnapshot.child('role').val() == "player" ){
            db.ref('trainingControl').child('viewControl').child(this.trainingData.teamKey).child(trainingKey).child('pending').child(childSnapshot.key).set(userSimpleModel)
            db.ref('trainingControl').child('availabilityControl').child(this.trainingData.teamKey).child(trainingKey).child('available').child(childSnapshot.key).set(userSimpleModel)
          }

        })
      })


      var countRef = this.$firebaseRefs.counts.child('trainingsCount').child('count')

      countRef.transaction(function(count) {
        if (count) {
          count = count + 1;
        }else{
          count = 1
        }
        return count;
      })


      this.$router.go(-1)
    
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// getAge(birthdate) {
    //   var today = new Date();
    //   var birthDate = new Date(birthdate);
    //   var age = today.getFullYear() - birthDate.getFullYear();
    //   var m = today.getMonth() - birthDate.getMonth();
    //   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //       age--;
    //   }    
    //   return age;
    // }
    // console.log(this.newUser.birthdate)
      // const timestamp = new Date(this.newUser.birthdate).getTime()
      // console.log(timestamp)
      // const dateFromTimestamp = new Date(timestamp)
      // console.log(dateFromTimestamp)

      // if(this.$route.params.teamid != null){
      //   console.log(this.$route.params.teamid)
      // }else{
      //   console.log("No hay id equipo")
      // }

      // Get a key for a new User.
      // var newUserKey = this.$firebaseRefs.users.push().key;

      // this.$firebaseRefs.users.child(newUserKey).set({
      //    name: this.userName,
      //    team: this.teamSelect
      // })

      // this.$firebaseRefs.users.child().set({
      //   name: this.userName,
      //   team: this.teamSelect
      // })